import { useMemo } from 'react';
import { useClients } from './useClients';

export function useCalendar() {
  const { clients, loading, error } = useClients();

  const allPosts = useMemo(() => {
    const posts = [];
    for (const client of clients) {
      for (const post of client.posts) {
        posts.push({ ...post, clientName: client.name });
      }
    }
    return posts.sort((a, b) => a.date.localeCompare(b.date));
  }, [clients]);

  const upcomingPosts = useMemo(() => {
    const today = new Date().toISOString().split('T')[0];
    return allPosts.filter(p => p.date >= today).slice(0, 5);
  }, [allPosts]);

  const postsByWeek = useMemo(() => {
    const grouped = {};
    for (const post of allPosts) {
      const week = post.week || 'Sem semana';
      if (!grouped[week]) grouped[week] = [];
      grouped[week].push(post);
    }
    return grouped;
  }, [allPosts]);

  return { allPosts, upcomingPosts, postsByWeek, loading, error };
}
